import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteActivityUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteActivity implements DeleteActivityUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: DeleteActivityUseCaseInterface.Params,
  ): Promise<DeleteActivityUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.activityId}`,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
